import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../shared/constants';
import { mobilePattern } from '../../shared/constants';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-appointment-create',
	templateUrl: './appointment-create.component.html',
	styleUrl: './appointment-create.component.scss'
})
export class AppointmentCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		}
	];
	refNo: any = null;
	itemIdInNoCandidateCase: any = null;
	pagetitle = "Create Training";
	moduleForm: FormGroup = this.formBuilder.group({
		/* main_company: [null, [Validators.required]], */
		company: [null, [Validators.required]],
		profile: [null, [Validators.required]],
		DOE: [null, [Validators.required]],
		numberOfCandidate: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
		numberOfTrainers: [null, [Validators.pattern(/^\d+$/)]],
		appointments: this.formBuilder.array([]),
	});
	showLoader: boolean = false;
	showDeleteLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	hideP = true;
	formSubmitted = false;
	companyList: any[] = [];
	/* vesselList: any[] = [];
	branchList: any[] = []; */
	rankList: any[] = [];
	profileList: any[] = [];
	trainerList: any[] = [];
	/* pdfDownloadLoader: any = null; */

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.refNo = routeParams["refNo"] == undefined ? null : routeParams["refNo"];
			this.getProfileList();
			this.getTrainers();
			this.getRankList();
			this.getCompanyList();
			if (this.refNo) {
				this.breadcrumbList.push({ path: "/app/edit-appointment/" + this.refNo, name: "Edit Training" });
				this.pagetitle = "Edit Training";
				this.getDetails();
			} else {
				this.addAppointments();
				this.apptCountChanged();
				this.breadcrumbList.push({ path: "/app/create-appointment", name: "Create Training" });
			}
		});
	}

	get get_appointments() {
		return this.moduleForm.controls['appointments'] as FormArray;
	}

	get f() { return this.moduleForm.controls; }

	addAppointments() {
		const form = this.formBuilder.group({
			id: [null],
			name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			email: [null, [Validators.email]],
			phone_no: [null],
			rank: [null, [Validators.required]],
			gender: [null, [Validators.required]],
			dob: [null],
			age: [null],
			attend: [null],
			selected: [false],
			id_dec: [null],
			trainers_id: [null, [Validators.required]],
			/* f_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			m_name: [null],
			l_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
			company: [null, [Validators.required]],
			branch: [null],
			vessel: [null],
			crew_id: [null], */
		});
		form.controls.age.disable();
		this.get_appointments.push(form);
		/* this.vesselList.push([]);
		this.branchList.push([]); */
	}

	apptCountChanged() {
		this.f.numberOfCandidate.setValue(this.get_appointments.length);
	}

	showError1(field: string) {
		let f: any = this.f[field];
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_appointments.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	calculateAge(index: number) {
		let f: any = this.get_appointments.controls[index].get("dob");
		let f1: any = this.get_appointments.controls[index].get("age");
		let value = f.value;
		if (value == null) {
			f1.setValue(null);
			return;
		}
		var ageDifMs = Date.now() - value.getTime();
		var ageDate = new Date(ageDifMs);
		f1.setValue(Math.abs(ageDate.getUTCFullYear() - 1970));
	}

	getRankList() {
		this.apiService.getAllRankList().subscribe({
			next: (data: any) => {
				this.rankList = data;
			}, error: (error) => {
				this.rankList = [];
				if (error.status == 401) { return }
			}
		});
	}

	getProfileList() {
		this.apiService.getAllProfileList().subscribe({
			next: (data: any) => {
				this.profileList = data.data;
			}, error: (error) => {
				this.profileList = [];
				if (error.status == 401) { return }
			}
		});
	}

	getTrainers() {
		this.apiService.listTrainers().subscribe({
			next: (data: any) => {
				this.trainerList = data.map((t: any) => {
					t.full_name = `${t.first_name} ${t.last_name}`;
					return t;
				});
			}, error: (error) => {
				this.trainerList = [];
				if (error.status == 401) { return }
			}
		});
	}

	getCompanyList() {
		this.apiService.getAllCompanyList().subscribe({
			next: (data: any) => {
				this.companyList = data;
			}, error: (error) => {
				this.companyList = [];
				if (error.status == 401) { return }
			}
		});
	}

	/* getVesselListByCompany(index: number, clearVessel: boolean) {
		let f2: any = this.get_appointments.controls[index].get("company");
		if (clearVessel) {
			this.get_appointments.controls[index].get("vessel")?.setValue(null);
		}
		if (f2.value) {
			this.apiService.getVesselListByCompany({ company: f2.value }).subscribe({
				next: (data: any) => {
					this.vesselList[index] = data;
				}, error: (error) => {
					this.vesselList[index] = [];
				}
			});
		} else {
			this.vesselList[index] = [];
		}
	}

	getBranchListByCompany(index: number, clearBranch: boolean) {
		let f2: any = this.get_appointments.controls[index].get("company");
		if (clearBranch) {
			this.get_appointments.controls[index].get("branch")?.setValue(null);
		}
		if (f2.value) {
			this.apiService.getBranchListByCompany({ company: f2.value }).subscribe({
				next: (data: any) => {
					this.branchList[index] = data;
				}, error: (error) => {
					this.branchList[index] = [];
				}
			});
		} else {
			this.branchList[index] = [];
		}
	} */

	getDetails() {
		this.pageLoading = true;
		this.apiService.getApptDetails(this.refNo).subscribe({
			next: (data: any) => {
				try {
					this.f.profile.setValue(data[0].profile);
					/* this.f.main_company.setValue(data[0].main_company); */
					this.f.company.setValue(data[0].company);
					this.f.DOE.setValue(this.apiService.getDateFromDateString(data[0].DOE));
					this.f.numberOfCandidate.setValue(data[0].numberOfCandidate);
					this.f.numberOfTrainers.setValue(data[0].numberOfTrainers);
				} catch (error) { }
				if (data.length == 1 && data[0].name == null/* data[0].f_name == null && data[0].l_name == null */) {
					this.itemIdInNoCandidateCase = data[0].id;
				} else {
					for (let i = 0; i < data.length; i++) {
						this.addAppointments();
						this.get_appointments.controls[i].get("id")?.setValue(data[i].encrypt_id);
						this.get_appointments.controls[i].get("id_dec")?.setValue(data[i].id);
						this.get_appointments.controls[i].get("name")?.setValue(data[i].name);
						this.get_appointments.controls[i].get("email")?.setValue(data[i].email);
						this.get_appointments.controls[i].get("phone_no")?.setValue(data[i].phone_no);
						this.get_appointments.controls[i].get("rank")?.setValue(data[i].rank);
						this.get_appointments.controls[i].get("gender")?.setValue(data[i].gender);
						this.get_appointments.controls[i].get("age")?.setValue(data[i].age);
						this.get_appointments.controls[i].get("dob")?.setValue(this.apiService.getDateFromDateString(data[i].dob));
						this.get_appointments.controls[i].get("attend")?.setValue(data[i].attend);
						this.get_appointments.controls[i].get("trainers_id")?.setValue(data[i].trainers_id);
						/* this.get_appointments.controls[i].get("f_name")?.setValue(data[i].f_name);
						this.get_appointments.controls[i].get("m_name")?.setValue(data[i].m_name);
						this.get_appointments.controls[i].get("l_name")?.setValue(data[i].l_name);
						this.get_appointments.controls[i].get("company")?.setValue(data[i].company);
						this.get_appointments.controls[i].get("branch")?.setValue(data[i].branch);
						this.get_appointments.controls[i].get("vessel")?.setValue(data[i].vessel);
						this.get_appointments.controls[i].get("crew_id")?.setValue(data[i].crew_id); */
						/* this.getVesselListByCompany(i, false);
						this.getBranchListByCompany(i, false); */
					}
				}
				this.pageLoading = false;
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	deleteAppt(index: number) {
		if (this.get_appointments.controls[index].get("id")?.value) {
			Swal.fire({
				title: 'Warning !!!',
				html: 'Are you sure you want to delete record?',
				icon: 'warning',
				showCancelButton: true,
				showConfirmButton: true,
				confirmButtonText: 'Delete',
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dc3545'
			}).then((result) => {
				if (result.value) {
					this.apiService.deleteAppt(this.get_appointments.controls[index].get("id")?.value).subscribe({
						next: data => {
							Swal.fire('Success', 'Deleted successfully', 'success');
							this.get_appointments.at(index).markAsUntouched();
							this.get_appointments.at(index).updateValueAndValidity();
							this.get_appointments.removeAt(index);
							this.apptCountChanged();
						}, error: (error) => {
							if (error.status == 401) { return }
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					});
				}
			})
		} else {
			this.get_appointments.at(index).markAsUntouched();
			this.get_appointments.at(index).updateValueAndValidity();
			this.get_appointments.removeAt(index);
			this.apptCountChanged();
		}
	}

	/* createCertificate(index: number) {
		this.pdfDownloadLoader = this.get_appointments.controls[index].get("id")?.value;
		this.apiService.createCertificate(this.get_appointments.controls[index].get("id")?.value).subscribe({
			next: (res: any) => {
				let pdfData: any = res.body;
				this.pdfDownloadLoader = null;
				let blob = new Blob([pdfData], { type: "application/pdf" });
				let fileName = this.get_appointments.controls[index].get("name")?.value + ".pdf";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.pdfDownloadLoader = null;
				if (error.status == 400) {
					const decodedString = String.fromCharCode(...new Uint8Array(error.error));
					this.toastr.error(decodedString, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				} else {
					this.toastr.error("Unable to download file", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			}, complete: () => { }
		});
	} */

	/* changeAttend(index: number) {
		let val = this.get_appointments.controls[index].get("attend")?.value;
		let payload = {
			value: val ? 1 : 0,
			id: this.get_appointments.controls[index].get("id")?.value
		}
		this.apiService.attendappt(payload).subscribe({
			next: data => {
				this.toastr.success("Saved Successfully", 'Success', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}, error: (error) => {
				if (error.status == 401) { return }
				Swal.fire('Error', 'Something went wrong.', 'error');
			}
		});
	} */

	saveAppt() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const len = this.get_appointments.controls.length;
		if (!len) {
			this.toastr.info("Please add candidate.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let action = "create";
		if (this.refNo) {
			action = "edit";
		}
		let appointments: any = [];
		let header: any = {
			profile: this.f.profile.value,
			numberOfCandidate: isNaN(this.f.numberOfCandidate.value) ? null : parseInt(this.f.numberOfCandidate.value),
			DOE: this.apiService.getDateStringFromDate(this.f.DOE.value),

			/* main_company: this.f.main_company.value, */
			company: this.f.company.value,
			numberOfTrainers: isNaN(this.f.numberOfTrainers.value) ? null : parseInt(this.f.numberOfTrainers.value),
		}
		for (let i = 0; i < len; i++) {
			let obj: any = {
				...header,
				id: this.get_appointments.controls[i].get("id")?.value,
				name: this.get_appointments.controls[i].get("name")?.value,
				email: this.get_appointments.controls[i].get("email")?.value,
				phone_no: this.get_appointments.controls[i].get("phone_no")?.value,
				rank: this.get_appointments.controls[i].get("rank")?.value,
				gender: this.get_appointments.controls[i].get("gender")?.value,
				dob: this.apiService.getDateStringFromDate(this.get_appointments.controls[i].get("dob")?.value),
				age: this.get_appointments.controls[i].get("age")?.value,
				trainers_id: this.get_appointments.controls[i].get("trainers_id")?.value,
				/* f_name: this.get_appointments.controls[i].get("f_name")?.value,
				m_name: this.get_appointments.controls[i].get("m_name")?.value,
				l_name: this.get_appointments.controls[i].get("l_name")?.value,
				company: this.get_appointments.controls[i].get("company")?.value,
				branch: this.get_appointments.controls[i].get("branch")?.value,
				vessel: this.get_appointments.controls[i].get("vessel")?.value,
				crew_id: this.get_appointments.controls[i].get("crew_id")?.value, */
			};
			if (action == "edit" /* && !obj.id */) {
				obj["ref_no"] = this.refNo;
			}
			appointments.push(obj);
		}
		if (!appointments.length) {
			let obj: any = {
				...header,
				id: null,
				name: null,
				email: null,
				phone_no: null,
				rank: null,
				gender: null,
				dob: null,
				age: null,
				trainers_id: null,
				/* f_name: null,
				m_name: null,
				l_name: null,
				company: null,
				branch: null,
				vessel: null,
				crew_id: null, */
			}
			if (action == "edit") {
				obj["ref_no"] = this.refNo;
				obj["id"] = this.itemIdInNoCandidateCase;
			}
			appointments.push(obj);
		}
		this.showLoader = true;
		this.apiService.createUpdateAppointment({ data: appointments }, action).subscribe({
			next: data => {
				this.showLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val == "This field must be unique.") {
								val = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val;
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val, 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}

						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/appointmentList']);
	}

	gotoQueAns() {
		let idList = [this.refNo];
		for (let i = 0; i < this.get_appointments.controls.length; i++) {
			if (this.get_appointments.controls[i].get("selected")?.value) {
				idList.push(this.get_appointments.controls[i].get("id_dec")?.value)
			}
		}
		if (idList.length > 1) {
			this.router.navigate(['/app/userans', idList.join("__")]);
		} else {
			this.toastr.error('Please select candidate', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}
}
